module.exports = __webpack_public_path__ + "img/plexus-10.ce78fbb0.png";